export class DataColumn{
    columnId:number;
    columnName:string;
}